/* eslint-disable import/order */
import React from 'react';
import { Formik, Form } from 'formik';
import { isEmpty } from 'ramda';

import { ROUTES } from 'utils/constants';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { useGetParams } from '../utils/useGetParams';
import { useTranslation } from 'react-i18next';
import { KEYS } from '../utils/constants';
import { handleTrackEvent } from '../utils/handleTrackEvent';
import { useEvieOnboardingContext } from '../EvieOnboardingProvider';
import { useValidateFields } from '../utils/useValidateFields';

import SolidButton from 'components/SolidButton';
import TextInput from 'components/Surveys/FormControlSurveys/FormComponents/TextInput';

const UserNameScreen = () => {
  const { t } = useTranslation();
  const { push, step } = useGetParams();
  const { params } = useEvieOnboardingContext();
  const { setFirstName } = useValidateFields();

  const [storedName, setStoredName] = useLocalStorage(KEYS.USER_NAME);

  const handleNext = async (values) => {
    const { firstName } = values;
    await setStoredName(firstName.trim());
    handleTrackEvent('Step clicked', { number: step + 1 });
    push(`${ROUTES.EVIE_ONBOARDING}?${params}&step=${step + 1}`);
  };

  return (
    <section className="username-screen">
      <div className="sections__form username-screen__form">
        <img src={require('assets/images/fuchsia-heart.png')} alt="Fuchsia Heart" className="username-screen__form_logo" />
        <h2 className="username-screen__form_label">{t('evieOnboarding.userName')}</h2>
        <Formik
          initialValues={{ firstName: storedName || '' }}
          validationSchema={setFirstName}
          validateOnMount
          onSubmit={handleNext}
        >
          {(formData) => {
            const isDisabled = isEmpty(formData.values.firstName) || !!formData.errors.firstName || formData.isSubmitting;
            return (
              <Form className="username-screen__form_container">
                <div className="form-input username-screen__form_input">
                  <TextInput
                    validate
                    longmessage
                    formikProps={formData}
                    name="firstName"
                    className="custom-input"
                    placeholder={t('evieOnboarding.userNamePlaceholder')}
                    autoComplete="given-name"
                  />
                </div>
                <SolidButton
                  disabled={isDisabled}
                  type="submit"
                  className={`username-screen__form_nextbtn ${isDisabled ? 'evie-disabled' : ''}`}
                >
                  {t('button.next')}
                </SolidButton>
              </Form>
            );
          }}
        </Formik>
      </div>
    </section>
  );
};

export default UserNameScreen;
